import {toast} from 'react-toastify'
import React, {ReactNode} from 'react';

import {ToastContentComponent} from 'module/Toast/ToastContentComponent';
import 'module/Toast/Toast.css'

type ToastType = 'info' | 'success' | 'warning' | 'error' | 'default'
type ToastIDType = string | number

const queue: { [name in string]?: ToastIDType } = {}

type AutoCloseTypes = false | number;

interface IToastOptions {
	autoClose?: AutoCloseTypes
}

/**
 * @param type
 * @param content
 * @param name for detecting duplicates (set to content when content is a string and name is undefined)
 * @param opts
 */
function _toast(
	type: ToastType,
	content: ReactNode,
	name?: string,
	opts?: IToastOptions,
) {
	if (typeof content === 'string' && !name) name = content

	let autoClose: AutoCloseTypes = false;
	if (opts && typeof opts.autoClose === 'number') autoClose = opts.autoClose;

	const comp = <ToastContentComponent name={name} content={content}/>;
	let toastId = name && queue[name] || undefined
	if (toastId) {
		toast.update(toastId, {
			render: comp,
			type,
		});
	} else {
		if (name) queue[name] = toastId
		toastId = toast(comp, {
			autoClose: autoClose,
			onClose: () => {
				if (name) queue[name] = undefined;
			},
			type,
		})
	}
	return toastId
}

export const toastMessage = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast('default', content, name, opts)
}
export const toastSuccess = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast('success', content, name, opts)
}
export const toastInfo = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast('info', content, name, opts)
}
export const toastWarn = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast('warning', content, name, opts)
}
// errors should get alerted to user! do not use toast, use ConfirmDialogComponent
